/**
 * SettingsTab - Tab content for organization settings
 */
import StatusBadge from "./StatusBadge";
import { AlertCircle } from "lucide-react";

export default function SettingsTab({ org, myRole }) {
  return (
    <div className="space-y-6" data-testid="settings-tab">
      <div className="bg-card border border-border rounded-lg p-5 space-y-4">
        <h3 className="font-medium">Organization Details</h3>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-muted-foreground text-xs">Name</p>
            <p className="font-medium">{org.name}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs">Plan</p>
            <p className="font-medium capitalize">{org.plan_key}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs">Billing Interval</p>
            <p className="font-medium capitalize">{org.interval}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs">Status</p>
            <StatusBadge status={org.status} />
          </div>
          <div>
            <p className="text-muted-foreground text-xs">Created</p>
            <p className="font-medium">
              {new Date(org.created_at).toLocaleDateString()}
            </p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs">Members</p>
            <p className="font-medium">{org.member_count} / 10</p>
          </div>
        </div>
      </div>

      {org.status !== "active" && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex gap-3">
          <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-amber-800">
              Organization not yet active
            </p>
            <p className="text-xs text-amber-700 mt-1">
              Your organization plan is currently{" "}
              <strong>{org.status}</strong>. Contact our team at{" "}
              <a href="mailto:ask@cbaiq.com" className="underline">
                ask@cbaiq.com
              </a>{" "}
              if you need assistance.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
